module.exports = __webpack_public_path__ + "static/media/filtered-points.84e56f7f.geojson";